import HomePage from '@/components/HomePage';
import AdminPage from '@/components/AdminPage';
import DangerRoomPage from '@/components/DangerRoomPage';
import { SeriesPage } from '@/components/SeriesPage';
import { EpisodesAdminPage } from '@/components/EpisodesAdminPage';
import TeamPage from '@/components/TeamPage';
import ArtistRoomPage from '@/components/ArtistRoomPage';
import TermsPage from '@/components/TermsPage';
import PrivacyPage from '@/components/PrivacyPage';
import FloatingAudioControls from '@/components/FloatingAudioControls';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/hooks/use-theme';
import { JSX, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App(): JSX.Element {
  return (
    <ThemeProvider>
      <div
        id='app-container'
        className='relative min-h-screen flex flex-col'
      >
        <ScrollToTop />

        {/* Floating X (Twitter) button — visible on all pages */}
        <a
          href="https://x.com/dangerdan_nft"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed top-5 right-5 z-50 flex items-center justify-center transition-all duration-200 w-10 h-10 md:w-20 md:h-20"
          style={{
            borderRadius: '50%',
            background: 'rgba(8,13,31,0.85)',
            border: '2px solid rgba(124,252,0,0.4)',
            color: 'rgba(124,252,0,0.7)',
          }}
          onMouseEnter={e => {
            const el = e.currentTarget as HTMLAnchorElement;
            el.style.borderColor = '#7CFC00';
            el.style.color = '#7CFC00';
            el.style.boxShadow = '0 0 15px rgba(124,252,0,0.5)';
          }}
          onMouseLeave={e => {
            const el = e.currentTarget as HTMLAnchorElement;
            el.style.borderColor = 'rgba(124,252,0,0.4)';
            el.style.color = 'rgba(124,252,0,0.7)';
            el.style.boxShadow = 'none';
          }}
        >
          <span className="w-5 h-5 md:w-10 md:h-10 flex items-center justify-center">
            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </span>
        </a>

        {/* Floating audio controls — persists across all page navigations */}
        <FloatingAudioControls />

        <main id='app-main' className='flex-1'>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/admin' element={<AdminPage />} />
            <Route path='/series' element={<SeriesPage />} />
            <Route path='/episodes-admin' element={<EpisodesAdminPage />} />
            <Route path='/team' element={<TeamPage />} />
            <Route path='/artist' element={<ArtistRoomPage />} />
            <Route path='/terms' element={<TermsPage />} />
            <Route path='/privacy' element={<PrivacyPage />} />
            <Route path='/danger-room' element={<DangerRoomPage />} />
          </Routes>
        </main>

        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
